import React, {Fragment, useState, useEffect} from 'react';
import {Menu, Transition} from '@headlessui/react';
import {dropdown} from 'assets/images/images';
import {fetchBAASCurrencies} from 'requests/queries/baas';
import {useQuery} from 'react-query';

export default function CurrencyDropdown({onCurrencyChange}) {
  const [selectedCurrency, setSelectedCurrency] = useState(null);

  const {data, isLoading} = useQuery(
    ['currency'],
    () => fetchBAASCurrencies(),
    {
      retry: false,
      meta: {preventGlobalError: true},
    },
  );

  const currencies = React.useMemo(
    () => data?.entity?.currencies || [],
    [data],
  );

  useEffect(() => {
    if (!selectedCurrency && currencies.length > 0) {
      const defaultCurrency =
        currencies.find(currency => currency.code === 'NGN') || currencies[0];
      setSelectedCurrency(defaultCurrency);
      onCurrencyChange(defaultCurrency);
    }
  }, [currencies, selectedCurrency, onCurrencyChange]);

  useEffect(() => {
    if (selectedCurrency) {
      onCurrencyChange(selectedCurrency);
    }
  }, [selectedCurrency, onCurrencyChange]);

  if (isLoading) {
    return (
      <div className="w-[180px] h-10 bg-[#e5e7eb] rounded animate-pulse mt-6"></div>
    );
  }

  if (currencies.length === 0) {
    return <div>No currencies available</div>;
  }

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="inline-flex   w-fit text-start justify-between items-center mt-6 rounded-md border border-[#CECED2] bg-white px-4 py-2 text-base font-medium text-[#080917] hover:bg-grey-50">
          {selectedCurrency?.name || 'Select Currency'}
          <img src={dropdown || '/placeholder.svg'} alt="dropdown" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute left-0 z-10 mt-2 w-[200px] overflow-y-auto max-h-[250px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            {currencies.map(currency => (
              <Menu.Item key={currency.code}>
                {({active}) => (
                  <button
                    onClick={() => setSelectedCurrency(currency)}
                    className={`${
                      active ? 'bg-grey-100 text-black' : 'text-grey-700'
                    } block w-full px-4 py-2 text-left text-sm`}
                  >
                    {currency.name} ({currency.symbol})
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
